if (!customElements.get('mf-category-showcase')) {
  customElements.define('mf-category-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this.controls = [...this.querySelectorAll('[data-category]')];
      this.pictures = [...this.querySelectorAll('[data-picture]')];
      this.controls.forEach(control => {
        control.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.select(control);
        }, options);
        control.addEventListener('focus', () => this.select(control), options);
        control.addEventListener('click', () => this.select(control), options);
        control.addEventListener('keydown', event => {
          if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.controls.indexOf(control);
          const last = this.controls.length - 1;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? last : (index + (['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : last)) % this.controls.length;
          this.controls[next].focus();
        }, options);
      });
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
    }
    select(control) {
      const id = control.dataset.category;
      if (this.activeId === id) return;
      this.activeId = id;
      this.controls.forEach(item => item.classList.toggle('is-active', item === control));
      this.pictures.forEach(picture => {
        const active = picture.dataset.picture === id;
        picture.hidden = !active;
        picture.classList.toggle('is-active', active);
      });
    }
  });
}
